package games.polyclub.website.frontend.store.components

import games.polyclub.frontend.lib.react.simplified.SFC
import games.polyclub.frontend.lib.react.simplified.tags.img
import games.polyclub.service.player.id.api.OnlineMojangPlayerId
import games.polyclub.service.player.id.api.PlayerId
import games.polyclub.tool.functional.Option
import js.core.jso
import react.Props
import web.cssom.px

external interface AvatarIconProps : Props {
    var isBlank: Boolean?
    var isLoading: Boolean?
    var minecraftId: Option<PlayerId>?
}

val AvatarIcon = SFC<AvatarIconProps> { props ->
    img {
        src = if (props.isBlank == true) {
            "https://crafatar.com/avatars/6ab43178-89fd-4905-97f6-0f67d9d76fd9?size=16"
        } else if (props.isLoading == true) {
            "/img/loading-bigger.svg"
        } else {
            props.minecraftId?.map { it as? OnlineMojangPlayerId }?.map {
                "https://crafatar.com/avatars/${it.mojangId}?size=16&overlay"
            }?.let {
                it.getOrNull() ?: "/img/sadcreeper.png"
            }
        }
        width = 16.0
        height = 16.0
        style = jso {
            width = 16.px
            height = 16.px
        }
    }
}
